var BaseViews = require('../base');
var CartItems = require('./cart-review/cart-items');
var CartLocationDisplay = require('./cart-location-display');
var StringUtils = require('../../utils/strings');
var CartErrorMessage = require('./cart-review/cart-error-message');
var CartTotalWeight = require('./cart-review/cart-total-weight');
var CartGiftForm = require('./cart-gift-form/cart-gift-form');
var CartDeliveryAddressForm = require('./cart-delivery-address/cart-delivery-address-form');
var DeliveryPostalCodeForm = require('../delivery-postal-code-form');
var CartDeliveryPhoneForm = require('./cart-delivery-address/cart-delivery-phone-form');
var CartDeliveryNotesForm = require('./cart-delivery-address/cart-delivery-notes-form');
var CartDeliveryTip = require('./cart-delivery-address/cart-delivery-tip');
var lsCache = require('lscache');

require('./cart-review/cart-review.scss');
require('./cart-payment/credit-card-sprites/sprites.scss');

var CartReview = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-review',
    template: require('./cart-review/cart-review.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'light',
                errors: null,
                errorMessage: null,
                _appChannel: null
            }
        );
        this.errorsFixed = 0;
        this.cartCost = this.options._appChannel.request('cart:get:total:cost');
        this.paymentModel = this.options._appChannel.request('cart:get:payment:model');
        this.deliveryModel = this.options._appChannel.request('cart:get:delivery:model');
    },
    _updateCartCost: function (cartCost) {
      this.cartCost = cartCost;
      this.ui.cartTotalCost.html(StringUtils.currency(cartCost.total));
      this.ui.cartSubTotal.html('Subtotal: ' + StringUtils.currency(cartCost.subTotal));
      this.ui.cartDeliveryTotal.html('Delivery fee: ' + StringUtils.currency(cartCost.deliveryTotal));
      this.ui.deliveryReviewTipText.html(StringUtils.decimalToPercentage(cartCost.tipPercentage) + ' Tip: ' + StringUtils.currency(cartCost.tipTotal));
      this.ui.cartTax.html('Tax: ' + StringUtils.currency(cartCost.tax));
      this.ui.cartDeposit.html('Recycling Deposit: ' +  StringUtils.currency(cartCost.depositTotal));
      this._maybeRenderRecyclingDeposit();
      this._maybeRenderDeliveryLineItems();
    },
    _maybeRenderDeliveryLineItems: function () {
      if (this.deliveryModel.get('deliveryMethod') == 'local_delivery') {
        this.ui.cartDeliveryTotal.show();
        this.ui.cartTip.show();
      } else {
        this.ui.cartDeliveryTotal.hide();
        this.ui.cartTip.hide();
      }
    },
    _renderNextAvailableDeliveryMessage: function (deliveryNextAvailable) {
      var deliveryMessage = '';
      if (deliveryNextAvailable) {
        if (deliveryNextAvailable.isToday) {
          deliveryNextAvailable.day = 'today';
        } else {
          deliveryNextAvailable.day = deliveryNextAvailable.day.charAt(0).toUpperCase() + deliveryNextAvailable.day.slice(1);
        }
        
        var deliveryMessage = ' Delivery will be available again ' + 
        deliveryNextAvailable.day + 
        ' between ' + 
        deliveryNextAvailable.startTime + 
        ' and ' +
        deliveryNextAvailable.endTime;
      }

      this.ui.deliveryAvailableLaterMessage.html(deliveryMessage);
      this.ui.deliveryAvailableLater.css('display', 'block');
    },
    _maybeRenderLocalDeliveryOption: function () {

       // if delivery is not available everywhere, hide the option
       if (this.options._appChannel.request('validate:is:delivery:available:anywhere') == false) {
          if (this.deliveryModel.get('deliveryMethod') == 'local_delivery') {
            this.deliveryModel.set('deliveryMethod', 'pickup');
          }
          this.ui.deliveryLocalStandardRadioGroup.hide();

          // delivery is unavailable everywhere and no error..
          if (!this.deliveryUnavailableError) {
            return;
          }  
       }

      // check delivery times and when its next available.
      var isDeliveryAvailableAtThisTime = this.options._appChannel.request('validate:is:delivery:available:at:this:time');

      if ((isDeliveryAvailableAtThisTime.deliveryAvailableAtThisTime == false ||
        parseInt(isDeliveryAvailableAtThisTime.deliveryAvailableAtThisTime) == 0) && 
        !this.deliveryUnavailableError) {

        if (isDeliveryAvailableAtThisTime.deliveryNextAvailable &&
        isDeliveryAvailableAtThisTime.deliveryNextAvailable.available == true) {
          this._renderNextAvailableDeliveryMessage(isDeliveryAvailableAtThisTime.deliveryNextAvailable);
        } else {
          this._renderNextAvailableDeliveryMessage(false);
        }
      }
    },
    serializeData: function () {
      var currentSelectedLocation = this.options._appChannel.request('get:filter:location:details');
      var deliveryMinDollarAmount = currentSelectedLocation.get('delivery_min_dollar_amount');
      if (!deliveryMinDollarAmount) {
        deliveryMinDollarAmount = 0;
      }

      return {
        cartTotalCost: StringUtils.currency(this.cartCost.total),
        cartTax: StringUtils.currency(this.cartCost.tax),
        cartDeposit: StringUtils.currency(this.cartCost.depositTotal),
        cartSubTotal: StringUtils.currency(this.cartCost.subTotal),
        cartDeliveryTotal: StringUtils.currency(this.cartCost.deliveryTotal),
        cartDeliveryTipTotal: StringUtils.currency(this.cartCost.tipTotal),
        cartDeliveryTipPercentage: StringUtils.decimalToPercentage(this.cartCost.tipPercentage),
        deliveryMinDollarAmount: StringUtils.currency(deliveryMinDollarAmount),
        creditCardPaymentEnabled: farmacy.settings.payments.creditCardPaymentEnabled,
        interacPaymentEnabled: farmacy.settings.payments.interacPaymentEnabled
      }
    },
    ui: {
      cartTotalCost: '.fmcy-cart-review-total-cost',
      cartSubTotal: '.fmcy-cart-review-sub-total',
      cartDeliveryTotal: '.fmcy-cart-review-delivery-total',
      cartTip: '.fmcy-cart-review-tip',
      cartTax: '.fmcy-cart-review-tax',
      cartDeposit: '.fmcy-cart-review-deposit',
      cartLeftColumn: '.fmcy-cart-review-left-column',
      cartRightColumn: '.fmcy-cart-review-right-column',
      payNowCreditRadio: '#fmcy-cart-paynow-credit-radio',
      payNowInteracRadio: '#fmcy-cart-paynow-interac-radio',
      payLaterRadio: '#fmcy-cart-paylater-radio',
      payLaterRadioGroup: '.fmcy-cart-paylater-group',
      payNowCreditRadioGroup: '.fmcy-cart-paynow-credit-group',
      deliveryPickupRadio: '#fmcy-cart-delivery-pickup-radio',
      deliveryPickupLocationReviewEdit: '.local-pickup-location-review-edit',
      deliveryLocalStandardRadio: '#fmcy-cart-delivery-local-standard-radio',
      changeLocationLink: '.location-change-click-here',
      paymentMethodErrorMessage: '.fmcy-cart-review-payment-method-error-message',
      deliveryDefaultErrorMessage: '.fmcy-cart-review-delivery-default-error-message',
      deliveryLocalStandardRadioGroup: '.fmcy-cart-delivery-local-standard-radio-group',
      deliveryAvailableLater: '.fmcy-cart-delivery-available-later',
      deliveryAvailableLaterMessage: '.fmcy-cart-delivery-available-next-message',
      deliveryReviewTip: '.fmcy-cart-review-tip',
      deliveryReviewTipText: '.fmcy-cart-review-tip-text'
    },
    events: {
      'change input[type=radio][name=payRadioGroup]': 'onPayRadioChange',
      'change input[type=radio][name=deliveryRadioGroup]': 'onDeliveryRadioChange',
      'click @ui.changeLocationLink': 'onLocationChangeClicked',
      'click @ui.deliveryReviewTip': 'onCartChangeTip'
    },
    onPayRadioChange: function (event) {
      switch (event.currentTarget.value) {
        case 'paylater':
          this.options._appChannel.trigger('cart:set:payment:method', 'instore');
        break;
        case 'paynow_interac':
          this.options._appChannel.trigger('cart:set:payment:method', 'interac');
        break;
        default:
          //paynow_credit
          this.options._appChannel.trigger('cart:set:payment:method', 'credit');
        break;
      }
      this._maybeRenderGiftForm({
        error: false
      });
      this.ui.paymentMethodErrorMessage.hide();
    },
    _renderPostalCodeForm: function () {
        var self = this;
        this.deliveryPostalCodeForm = new DeliveryPostalCodeForm({
            _appChannel: this.options._appChannel,
            error: this.postalCodeError,
            errorMessage: this.postalCodeErrorMessage,
            referrer: 'cart'
        })

        this.cartLocalDeliveryPostalCodeRegion.show(this.deliveryPostalCodeForm);
    },
    _renderDeliveryNotes: function () {
      this.cartDeliveryNotesForm = new CartDeliveryNotesForm({
        _appChannel: this.options._appChannel,
        model: this.deliveryModel,
      });
      this.cartLocalDeliveryNotesRegion.show(this.cartDeliveryNotesForm);
    },
    onCartChangeTip: function () {
      this._renderDeliveryTip();
    },
    _renderDeliveryTip: function () {
      var self = this;
      this.cartDeliveryTip = new CartDeliveryTip({
        _appChannel: this.options._appChannel,
        model: this.deliveryModel,
        expandedDetails: false,
        selectedValue: this.cartCost.tipPercentage
      });

      this.cartDeliveryTip.on('update', function () { 
        self.options._appChannel.trigger('cart:items:updated');
      });

      this.cartTipBelowRegion.show(this.cartDeliveryTip);
    },
    _renderDeliveryPhone: function () {
      this.cartDeliveryPhonesForm = new CartDeliveryPhoneForm({
        _appChannel: this.options._appChannel,
        model: this.deliveryModel,
        error: this.phoneError,
        errorMessage: this.phoneErrorMessage
      });
      this.cartLocalDeliveryPhoneRegion.show(this.cartDeliveryPhonesForm);
    },
    _renderDeliveryAddressForm: function () {
      var self = this;
      this.cartDeliveryAddressForm = new CartDeliveryAddressForm({
        _appChannel: this.options._appChannel,
        model: this.deliveryModel.get('cartDeliveryAddressModel'),
        error: this.addressError,
        errorMessage: this.addressErrorMessage
      });
      this.cartLocalDeliveryAddressRegion.show(this.cartDeliveryAddressForm);

    },
    _deliveryRadioHighlight: function (deliveryMethod) {

      if (deliveryMethod == 'pickup') {
        this.cartLocalDeliveryPostalCodeRegion.empty();
        this.cartLocalDeliveryAddressRegion.empty();
        this.cartLocalDeliveryNotesRegion.empty();
        this.cartLocalDeliveryTipRegion.empty();
        this.cartTipBelowRegion.empty();
        this.cartLocalDeliveryPhoneRegion.empty();
      } else {
        this.ui.deliveryPickupLocationReviewEdit.hide();
      }

      var currentSelectedLocationSlug = this.options._appChannel.request('get:filter:location:details').get('slug');

      var deliveryAdddressModel = this.deliveryModel.get('cartDeliveryAddressModel');
      deliveryAdddressModel.set('local_delivery_method', deliveryMethod);
      lsCache.set('cartDeliveryAddressModel', deliveryAdddressModel.toJSON(), 14400000);

      switch (deliveryMethod) {
        case 'pickup':
          this.ui.deliveryPickupRadio.prop('checked', true);
          this.ui.deliveryPickupRadio.checked = true;
          this.ui.deliveryAvailableLater.addClass('delivery-later-message-soften');
        break;
        default:
          // local delivery
          this.ui.deliveryLocalStandardRadio.prop('checked', true);
          this.ui.deliveryLocalStandardRadio.checked = true;
          this._renderPostalCodeForm();
          this._renderDeliveryAddressForm({
            error: this.addressError
          });
          this._renderDeliveryNotes();
          this._renderDeliveryPhone();
          if (this.ui.deliveryAvailableLater.hasClass('delivery-later-message-soften')) {
            this.ui.deliveryAvailableLater.removeClass('delivery-later-message-soften');
          }
        break;
      }

      switch (deliveryMethod) {
        case 'pickup':
          this.ui.deliveryPickupLocationReviewEdit.show();
          this.options._appChannel.trigger('cart:set:delivery:method', deliveryMethod);
        break;
        default:
          // local delivery
          this.options._appChannel.trigger('cart:set:delivery:method', deliveryMethod);
        break;
      }

      this._hideShowPaymentMethods(deliveryMethod);
    },
    onDeliveryRadioChange: function (event) {
      this._deliveryRadioHighlight(event.currentTarget.value);
      this.options._appChannel.trigger('cart:items:updated');
    },
    _hideShowPaymentMethods: function (deliveryMethod) {
      if (deliveryMethod == 'pickup') {
        this.ui.payLaterRadioGroup.show();
        var currentSelectedLocation = this.options._appChannel.request('get:filter:location:details');
        if (farmacy.settings.payments.creditCardPaymentEnabled === true && (currentSelectedLocation.get('payments_allow_online') === true || currentSelectedLocation.get('payments_allow_online') === '1')) {
          this.options._appChannel.trigger('cart:set:payment:method', 'credit');
          this.ui.payNowCreditRadio.prop('checked', true);
          this.ui.payNowCreditRadio.checked = true;
          this.ui.payNowCreditRadioGroup.show();
        } else {
          this.options._appChannel.trigger('cart:set:payment:method', 'instore');
          this.ui.payNowCreditRadio.prop('checked', false);
          this.ui.payLaterRadio.prop('checked', true);
          this.ui.payLaterRadio.checked = true;
          this.ui.payNowCreditRadioGroup.hide();
        }
      } else {
        this.ui.payLaterRadioGroup.hide();
        this.options._appChannel.trigger('cart:set:payment:method', 'credit');
        this.ui.payNowCreditRadio.prop('checked', true);
        this.ui.payNowCreditRadio.checked = true;
        this.ui.payNowCreditRadioGroup.show();
      }
    },
    onLocationChangeClicked: function (event) {
      this.options._appChannel.trigger('menu:overlay:view:close');
      this.options._appChannel.trigger('location:selection:view', {
        referrer: 'cart',
        skipAgeGate: true
      });
    },
    regions: {
        cartItemsRegion: '.fmcy-cart-review-items-region',
        errorMessageRegion: '.fmcy-cart-review-error-message-region',
        totalWeightRegion: '.fmcy-cart-total-weight-region',
        cartGiftRegion: '.fmcy-cart-gift-form-region',
        cartPickupLocationRegion: '.fmcy-cart-pickup-location-region',
        cartLocalDeliveryAddressRegion: '.fmcy-cart-delivery-address-region',
        cartLocalDeliveryPostalCodeRegion: '.fmcy-cart-delivery-postal-code-region',
        cartLocalDeliveryNotesRegion: '.fmcy-cart-delivery-notes-region',
        cartLocalDeliveryTipRegion: '.fmcy-cart-delivery-tip-region',
        cartLocalDeliveryPhoneRegion: '.fmcy-cart-delivery-phone-region',
        cartTipBelowRegion: '.fmcy-cart-tip-below-region'
    },
    _renderTotalWeight: function (options) {
      this._totalWeightMessage = new CartTotalWeight(options);
      this.totalWeightRegion.show(this._totalWeightMessage);
    },
    _hideTotalWeight: function () {
      this.totalWeightRegion.empty();
    },
    _updateCartTotalWeight: function (weight) {
      if (this.collection.length > 0) {
        this._totalWeightMessage.show();
      } else {
        this._totalWeightMessage.hide();
      }
      if (this._totalWeightMessage !== null) {
        this._totalWeightMessage.updateMessage(weight);
      }
    },
    _renderCartLocationDisplay: function () {
        this._cartLocationDisplay = new CartLocationDisplay({
          _appChannel: this.options._appChannel,
          hidePhotoSmallScreen: false
        });
        this.cartPickupLocationRegion.show(this._cartLocationDisplay);
    },
    _renderCartItems: function () {
      var self = this;
      this._cartItems = new CartItems({
          collection: this.collection,
          _appChannel: this.options._appChannel,
          errors: this.options.errors
      });
      this._cartItems.on('cart:remove:item', function (model) {
        if (model.get('error') === true) {
          self.errorsFixed += 1;
          if (self.options.errors == null || self.errorsFixed >= self.options.errors.length) {
            self._hideErrorMessage();
          }
        }
      });
      this.cartItemsRegion.show(this._cartItems);
    },
    _renderErrorMessage: function () {
      var errorMessageOptions = {};
      if (this.options.errorMessage !== null) {
        errorMessageOptions.message = this.options.errorMessage;
      }
      this._errorMessage = new CartErrorMessage(errorMessageOptions);
      this.errorMessageRegion.show(this._errorMessage);
    },
    _hideErrorMessage: function () {
      this.errorMessageRegion.empty();
    },
    _maybeRenderRecyclingDeposit: function () {
      if (this.cartCost.depositTotal == 0) {
        this.ui.cartDeposit.hide();
      } else {
        this.ui.cartDeposit.show();
      }
    },
    _maybeRenderGiftForm: function (options) {
      if (farmacy.settings.giftEnabled) {
        if (!this.giftForm) {
          this.giftForm = new CartGiftForm({
            model: this.paymentModel.get('cartGiftModel'),
            error: options.error
          });
          this.cartGiftRegion.show(this.giftForm);
        }
      } else {
        this.cartGiftRegion.empty();
        this.giftForm = null;
      }
    },
    addressError: false,
    addressErrorMessage: '',
    phoneError: false,
    phoneErrorMessage: '',
    postalCodeError: false,
    deliveryUnavailableError: false,
    postalCodeErrorMessage: '',

    onRender: function() {
      var self = this;
      this.collection = this.options._appChannel.request('cart:get:items');

      var weightErrorMessage = null
      var weightError = false;
      var giftFormError = false;
      this.addressError = false;
      this.phoneError = false;
      this.postalCodeError = false;
      this.deliveryUnavailableError = false;

      if (this.options.errors && this.options.errors.length > 0) {
        this._renderErrorMessage();
        //TODO: figure out why it's sorting when qty changed...
        //this.collection.setSort('error', 'desc');
        var errors = this.options.errors;
        
        errors.forEach(function (error) {
          if (error.code == 'overlimit' && error.message !== null) {
            weightErrorMessage = error.message
            weightError = true;
          }
          if (error.code == 'paymentmethod') {
            self.ui.paymentMethodErrorMessage.css('display', 'block');
          }
          if (error.code == 'giftform') {
            giftFormError = true;
          }
          if (error.code == 'deliveryminimum' ||
            error.code == 'deliveryunavailable' || 
            error.code == 'fetcherror') {
            self.ui.deliveryDefaultErrorMessage.html(error.message);
            self.ui.deliveryDefaultErrorMessage.css('display', 'block');
          }
          if (error.code == 'deliveryunavailable') {
            self.ui.deliveryDefaultErrorMessage.html(error.message);
            self.ui.deliveryDefaultErrorMessage.css('display', 'block');
            self.deliveryUnavailableError = true;
          }


          
          if (error.code == 'deliveryaddress') {
            self.addressError = true;
            self.addressErrorMessage = error.message;
          }
          if (error.code == 'phone') {
            self.phoneError = true;
            self.phoneErrorMessage = error.message;
          }
          if (error.code == 'postalcode') {
            self.postalCodeError = true;
            self.postalCodeMessage = error.message;
          }
        });
      }

      this._renderCartItems();

      var hideTotalWeight = true;
      if (this.collection.length > 0) {
        hideTotalWeight = false;
      }

      this._renderTotalWeight({
        _appChannel: this.options._appChannel,
        weight: this.options._appChannel.request('cart:get:total:weight'),
        weightError: weightError,
        hidden: hideTotalWeight,
        errorMessage: weightErrorMessage
      });

      this.listenTo(this.options._appChannel, 'cart:items:updated', function () {
          self._updateCartCost(self.options._appChannel.request('cart:get:total:cost'));
          self._updateCartTotalWeight(self.options._appChannel.request('cart:get:total:weight'));
          self.ui.deliveryDefaultErrorMessage.css('display', 'none');
      });

      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));

      this._onWindowResize();

      this._maybeRenderLocalDeliveryOption();
      this._maybeRenderDeliveryLineItems();
      this._maybeRenderRecyclingDeposit();

      switch (this.paymentModel.get('paymentMethod')) {
        case 'instore':
          this.ui.payLaterRadio.prop('checked', true);
          this.ui.payLaterRadio.checked = true;
        break;
        case 'interac':
          this.ui.payNowInteracRadio.prop('checked', true);
          this.ui.payNowInteracRadio.checked = true;
        break;
        default:
          //credit
          this.ui.payNowCreditRadio.prop('checked', true);
          this.ui.payNowCreditRadio.checked = true;
        break;
      }

      this._deliveryRadioHighlight(this.deliveryModel.get('deliveryMethod'));

      this._renderCartLocationDisplay();
      this._maybeRenderGiftForm({
        error: giftFormError
      });

      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    _onWindowResize: function (event) {
      var magicBuffer = 132;
      var minHeight = $(window).height() - magicBuffer;
      this.$el.css('minHeight', minHeight);
      this.ui.cartLeftColumn.css('minHeight', minHeight);
      this.ui.cartRightColumn.css('minHeight', minHeight);
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(self);
    }
});

module.exports = CartReview;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-review.js
 **/